import { ChangeDetectorRef, Component, OnInit , ViewEncapsulation } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {Path} from "../../util/path";
import {PaginaNucleoService} from "../../services/pagina-nucleo.service";
import {environment} from "../../../environments/environment";

@Component({
    selector: 'app-comissao-gams',
    templateUrl: './comissao-gams.component.html',
    styleUrls: ['./comissao-gams.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ComissaoGamsComponent implements OnInit {

  pagina: any;
  public  imageUrl = Path.URL_IMAGE.caminho;

  isLoading: boolean = true;
  isImage: boolean = true;

  readonly contatosMulherUrl =
    environment.apiUrlFile +
    'core-file-service/v1/external/arquivo/display?hash=ffc7cad3-a362-4e17-bf2c-674000b479ce';

  readonly imagemUrl =
    environment.apiUrlFile +
    'core-file-service/v1/external/arquivo/display?hash=94c3e483-dbb7-4b43-b6b5-178ae10191fb';

  constructor(
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    private paginaNucleoService: PaginaNucleoService
  ) { }

  ngOnInit(): void {
    this.buscarPagina();
  }

  buscarPagina(): void {
    this.isLoading = true;
    this.paginaNucleoService.buscarPaginaPorId('4').subscribe({
      next: (response: any) => {
        this.pagina = response;
        if (!this.pagina.arquivo || !this.pagina.arquivo.hash) {
          this.isImage = false;
        }
      },
      error: (err) => {
        console.error('Erro ao buscar a página:', err);
        this.pagina = null;
      },
      complete: () => {
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    });
  }
  public readonly Path = Path;
  voltarPagina(){
    window.history.back();
  }
}
